import './CustomerService.less';
export { default as CustomerService } from './CustomerService.js';
export { default } from './CustomerService.js';